import axios from 'axios';
// config
import { BASE_URL } from '../../config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: BASE_URL });

export const AUTH_HEADER_KEY = "jwt"
export const LANGUAGE_HEADER_KEY = "X-User-Language"

export const setAxiosAuth = (accessToken) => {
  axiosInstance.defaults.headers.common[AUTH_HEADER_KEY] = `${accessToken}`;
}

export const removeAxiosAuth = () => {
  delete axiosInstance.defaults.headers.common[AUTH_HEADER_KEY];
}

export const setAxiosLanguage = (language) => {
  axiosInstance.defaults.headers.common[LANGUAGE_HEADER_KEY] = language;
}

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorDetails = {
      message: error.message || `failed_request: ${error.config?.method?.toUpperCase()}:${error.config?.url}`,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      config: {
        url: error.config?.url,
        method: error.config?.method,
        // headers intentionally omitted — they contain the JWT auth token
      },
    };

    // Log the error for debugging
    console.error('failed_request:', JSON.stringify(errorDetails));

    // Create a new Error with the serialized details
    const serializedError = new Error(JSON.stringify(errorDetails));
    serializedError.originalError = error;
    serializedError.details = errorDetails;
    serializedError.userFacingMessage = errorDetails.data?.userFacingMessage || errorDetails.data?.message

    return Promise.reject(serializedError);
  }
);

export default axiosInstance;
